export const TimelineTone = {
  Default: 'default',
  Note: 'note',
} as const;

export type TTimelineTone = (typeof TimelineTone)[keyof typeof TimelineTone];

interface ITimelineToneClasses {
  accentTextClass: string;
  cardClass?: string;
  markerTextClass: string;
}

export const TIMELINE_TONE_CLASSES: Record<TTimelineTone, ITimelineToneClasses> = {
  [TimelineTone.Default]: {
    accentTextClass: 'text-secondary',
    cardClass: 'bg-surface-secondary',
    markerTextClass: 'text-secondary',
  },
  [TimelineTone.Note]: {
    accentTextClass: 'text-note-accent',
    cardClass: 'timeline-note-card',
    markerTextClass: 'text-note-marker',
  },
};
